import { create } from 'zustand';
import type { NewRegulatorOverride } from '../data/overridesRuntime';
import { fetchAndApplyOverrides } from '../data/refreshOverrides';

/**
 * regulatorLifecycleDraft — alta/baja directa de un regulador (Modo
 * Edición, ARS-05). Guardado real desde 2026-09-10 (antes: export a un
 * snippet que nunca llegaba a pegarse). Sin estado propio — para validar
 * colisión de ID (panel "+ Regulador") leer `addedRegulators` directo de
 * `overridesRuntime.ts`, no de aquí; tras cada escritura se vuelve a pedir
 * `GET /api/overrides` completo.
 */
export type { NewRegulatorOverride } from '../data/overridesRuntime';

interface DraftState {
  saving: boolean;
  stageAdd: (d: NewRegulatorOverride) => Promise<boolean>;
  stageRemove: (logicalId: number) => Promise<boolean>;
}

export const useRegulatorLifecycleDraft = create<DraftState>((set) => ({
  saving: false,
  stageAdd: async (d) => {
    set({ saving: true });
    try {
      const res = await fetch(`/api/overrides/regulator_added/${d.logicalId}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(d),
      });
      if (!res.ok) return false;
      await fetchAndApplyOverrides();
      return true;
    } catch {
      return false;
    } finally {
      set({ saving: false });
    }
  },
  stageRemove: async (logicalId) => {
    set({ saving: true });
    try {
      const res = await fetch(`/api/overrides/regulator_removed/${logicalId}`, {
        method: 'PUT',
        credentials: 'include',
      });
      if (!res.ok) return false;
      await fetchAndApplyOverrides();
      return true;
    } catch {
      return false;
    } finally {
      set({ saving: false });
    }
  },
}));
